import * as React from 'react';
import clsx from 'clsx';
import { makeStyles, Typography, useMediaQuery } from '@material-ui/core';
import { String_ShareLink1, String_ShareLink2 } from '../../utilities/StringHelper';
import { UserStateContext } from '../../providers/UserStateContextProvider';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import { ElementDimensions } from '../../styles/ElementDimensions'

const useStyles = makeStyles({
    logoContainer: {
        textAlign: 'center',
        marginLeft: 'auto',
        marginRight: 'auto',
        paddingTop: ElementDimensions.padding10 + 'px',
        paddingBottom: ElementDimensions.padding10 + 'px',
    },
    logoContainerLandscape: {
        textAlign: 'center',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    logoImage: {
        maxHeight: ElementDimensions.logoHeight + 'px',
    },
    shareContainer: {
        marginTop: ElementDimensions.margin10 + 'px',
        textAlign: 'center',
    },
    shareLink: {
        color: '#0000ff',
    },
    shareText: {
        
    },
});

const ShareLink = () => {
    const isPortrait = useMediaQuery('(orientation: portrait)');
    const userState = React.useContext(UserStateContext);
    const checkOutState = React.useContext(CheckOutStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });

    const formatShareLink = (index: number): string => {
        let linkString: string = String_ShareLink2.find(s => s.key === userState.state.locale)!!.value;
        let index1: number = linkString.indexOf('#');
        let index2: number = linkString.indexOf('#', index1 + 1);

        if (index === 0) {
            return linkString.substring(0, index1);
        }
        else if (index === 1) {
            return linkString.substring(index1 + 1, index2);
        }
        else {
            return linkString.substring(index2 + 1, linkString.length);
        }
    }

    const handleShareLinkClick = (event: React.MouseEvent<HTMLElement>) => {
        //@ts-ignore
        if (navigator.share) {
            //@ts-ignore
            navigator.share({
                title: 'Share ' + checkOutState.state.restaurantName + " Check Link",
                url: checkOutState.state.shareCheckInUrl!!,
            }).then(() => {
                
            })
            .catch(console.error);
            }
        else {
            alert("Phone Does Not Have Sharing Capabilities");
        }
    }

    return (
        <div className={classes.shareContainer}>
            <Typography variant="body1" className={classes.shareText}>
                {String_ShareLink1.find(s => s.key === userState.state.locale)!!.value}
            </Typography>
            <Typography variant="body1" className={classes.shareText}>
                {formatShareLink(0)}
                    <span className={classes.shareLink} onClick={handleShareLinkClick}>{formatShareLink(1)}</span>
                {formatShareLink(2)}
            </Typography>
        </div>
    );
}

export default ShareLink;